/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$("body").on("click", ".cart-notification__view-cart", function (e) {
  e.preventDefault();
  document.getElementById('mini-cart').open = true;
});

$(document).ready(function () {

  $(".has_enable_slider").on('afterChange', function(event, slick, currentSlide, nextSlide){
    var prev = parseInt(currentSlide - 1);
    var next = parseInt(currentSlide + 1);
    $(this).find('.slick-dots li').hide();
    $(this).find('.slick-dots li:eq('+currentSlide+')').show();    
    
    if($(this).find('.slick-dots li:eq('+prev+')').length == 0){
      $(this).find('.slick-dots li:eq('+next+')').show();     
      next = next + 1;
      $(this).find('.slick-dots li:eq('+next+')').show();    
    }else{
      $(this).find('.slick-dots li:eq('+prev+')').show();     
    }    
    if($(this).find('.slick-dots li:eq('+next+')').length == 0){
      prev = prev - 1;
      $(this).find('.slick-dots li:eq('+prev+')').show();    
    }else{
      $(this).find('.slick-dots li:eq('+next+')').show();     
    }    
  });
  
  
  $(".testimonial-list-secondary").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "25%",
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerPadding: "12%",
        },
      },
      {
        breakpoint: 740,
        settings: {
          centerPadding: "12%",
        },
      },
    ],
  });
  $(".image-columns-row").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  $('.list-collections--collage .list-collections__item-list,.list-collections__scroller .list-collections__item-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      mobileFirst: true,
      dots: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: 'unslick'
        }
      ]
  });
  
  // $('.product-list .scroller .product-list__inner--scroller').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     mobileFirst: true,
  //     arrows: false,
  //     prevArrow:`<button type='button' class='slick-prev'>
  //                 <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14">
  //                   <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"></path>
  //                   </svg>
  //                 </button>`,
  //     nextArrow:`<button type='button' class='slick-next'>
  //                   <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14">
  //                     <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"></path>
  //                   </svg>
  //                 </button>`,
  //     dots: true,
  //     responsive: [
  //       {
  //         breakpoint: 1000,
  //         settings: 'unslick'
  //       }
  //     ]
  // });

    $('.product-list__inner--slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:`<button type='button' class='slick-prev'>
                  <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14">
                    <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"></path>
                    </svg>
                  </button>`,
      nextArrow:`<button type='button' class='slick-next'>
                    <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14">
                      <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"></path>
                    </svg>
                  </button>`,
      dots: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
  });

  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });

  $("body").on("click", ".product-offer-code-block", function () {
    var copy_text = $(this).find('.product-offer-copy-code');
    var text = $(this).find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

    $(window).on('resize', function() {
        $('.carousel').slick('resize');
    });

  // $(".product-tab_link:first-child").addClass("active");
  $(".product-tab_content-block").hide();
  // $(".product-tab_content-block:first").show();

  // Click function  
  $(".product-tab_link").click(function () {
    var activeTab = $(this).attr("href");
    // $(".product-tab_link").removeClass("active");
    // $(".product-tab_content-block").hide();
    
    // $(this).addClass("active");
    // var activeTab = $(this).attr("href");
    // $(activeTab).fadeIn();

    if ($(this).hasClass('active')) {
      console.log('has');
      $(".product-tab_link").removeClass("active");
      $(".product-tab_content-block").hide();
    } else {
      $(".product-tab_link").removeClass("active");
      $(".product-tab_content-block").hide();
      $(this).toggleClass("active");
      $(activeTab).fadeToggle();
      console.log('no');
    }
    
    return false;
  });
  $('.product-tab_link:nth-child(2)').click();

  $('body').on('click','.fbt-product-bundle__cta', function(){    
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    var items = [];
    $(this).closest('.fbt-wrapper').find('.fbt-item').each(function(i,v){
       var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });          
    });    
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      _this.removeAttr("disabled");
      _this.removeAttr("aria-busy");
      window.location.href = '/checkout';
    }.bind(this));  
  });

  // $(".pagination__nav-item").on("click", function() {
  //   console.log('click');
  //   setTimeout(function(){ 
  //     $("body").scrollTop(0);
  //   }, 1000);
  //   console.log('click After');
  // });
  $('a[href^="#"]:not(.product-tab_link):not(.iWishAdd)').on('click',function (e) {
    var target = this.hash,
        $target = $(target);
  
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top-120
    }, 900, 'swing', function () {
      window.location.hash = target;
    });
  });
  $('a[href="read-more-less"]').click(function(e) {
    e.preventDefault();
    $(this).prev('.read-more_text-wrap').toggleClass('active');
    if ($(this).text() == "read more") {
      $(this).text("read less")
    } else {
      $(this).text("read more")
    }
  });

  $('body').on('change', '.cart_product-item-variant', function() {
    console.log('before changed')
    var variant_id = $(this).find('option:selected').attr('variant-id');
    var item_quantity = $(this).attr('quantity');
    var remove_variant_id = $(this).attr('current-variant-id');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: 0,
        id: remove_variant_id
      },
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        console.log('error',jqXHR, textStatus, errorThrown)
      },
      success: function (data){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async:false,
          data: { id: variant_id, quantity: item_quantity },
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            console.log('error',jqXHR, textStatus, errorThrown)
          },
          success: function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }
        });
      }
    });
  });

  $('.cart-offertext-slider-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: true,
      dots: false,
      prevArrow:`<button type='button' class='slick-prev'>
                    </button>`,
        nextArrow:`<button type='button' class='slick-next'>
                    </button>`,
    });

  // $('body').on('click','.product_view_cart-btn', function(e){
  //   e.preventDefault();
  //   document.getElementById('mini-cart').open = true;
  // })
  
});

document.addEventListener('cart:updated', function(event) {
  var cart = event.detail.cart;
  if(cart.item_count > 0){
    $('.cart-popover_wrapper').show();
  }else{
    $('.cart-popover_wrapper').hide();
  }
  if(($('#cart-mini-popover').length > 0) && ($('#cart-popover_cart-count').length > 0) && ($('.cart-popover_media').length > 0)){
    var img = cart.items[0]?.image;
    var smallImg = img?.replace(/(\.[^/.]+)$/, '_60x60_crop_center$1');
    $('#cart-popover_cart-count').html(`${cart.item_count} items`)
    $('.cart-popover_media').html(`<img src="${smallImg}" width="38" height="38" loading="lazy" class="cart-popover__image" />`)
  }
});
